module.exports = __webpack_public_path__ + "static/media/4.e7497d79.jpg";